import React from 'react';
import PropTypes from 'prop-types';
import Form from './Form';

const New = ({
  isModalOpen,
  onCloseHandler,
  onSubmitHandler,
  error,
  submitting,
  masterProducts,
  alreadyOptedOutProductIds,
  onPartyChange,
  productsLoading,
  hasNoMasterProducts,
  masterProductsError,
}) => (
  <Form
    isModalOpen={isModalOpen}
    onCloseHandler={onCloseHandler}
    onSubmitHandler={onSubmitHandler}
    error={error}
    submitting={submitting}
    masterProducts={masterProducts}
    alreadyOptedOutProductIds={alreadyOptedOutProductIds}
    onPartyChange={onPartyChange}
    productsLoading={productsLoading}
    hasNoMasterProducts={hasNoMasterProducts}
    masterProductsError={masterProductsError}
    action='new'
  />
);

New.propTypes = {
  isModalOpen: PropTypes.bool,
  onCloseHandler: PropTypes.func.isRequired,
  onSubmitHandler: PropTypes.func.isRequired,
  error: PropTypes.string,
  submitting: PropTypes.bool,
  // Raw, not mapped options: the picker filters by masterType, which does not
  // survive a {key,value,text} mapping.
  masterProducts: PropTypes.array,
  // Pre-checks the products this party is already opted out of, so the form also
  // answers "what is this party opted out of?" and cannot re-submit duplicates.
  alreadyOptedOutProductIds: PropTypes.array,
  // Fired when the typed party becomes identifiable, so the container can look up
  // what that party already holds. This wrapper forwards props by NAME rather than
  // spreading, so a new prop that is not listed here is silently dropped — which is
  // how the already-opted-out state stayed dead once before.
  onPartyChange: PropTypes.func,
  // The picker is fed by the seeded master products, so the create form has to
  // know both whether that query is still running and whether it came back
  // empty - they look the same in the options array but must not read the same.
  // A third state rides along: the query FAILED, which also looks empty and must
  // not be reported as "nothing is seeded".
  productsLoading: PropTypes.bool,
  hasNoMasterProducts: PropTypes.bool,
  masterProductsError: PropTypes.bool,
};

New.defaultProps = {
  isModalOpen: false,
  error: null,
  submitting: false,
  masterProducts: [],
  alreadyOptedOutProductIds: [],
  onPartyChange: null,
  productsLoading: false,
  hasNoMasterProducts: false,
  masterProductsError: false,
};

export default New;
